<template>
  <v-container fluid>
    <v-toolbar class="mb-4">
      <v-toolbar-title>Roles
        <v-btn icon small color="info"
               :to="{ name: 'roles-form', params: { role_id: 0 }, query: {instance_id: filter.instance_id}}">
          <v-icon size="18">add</v-icon>
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="app_filter">
        <div class="app_filter__item app_filter__item--sort">
          <v-select v-model="filter.instance_id" dense label="Instance" :items="instances" item-text="instance.name"
                    item-value="instance.id"></v-select>
        </div>
      </div>
    </v-toolbar>
    <v-card>
      <v-data-table :headers="headers" :loading="inProgress" :pagination.sync="list.pagination"
                    :total-items="list.pagination.totalItems" :items="list.items">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-right ">
              <div class="table_actions_btns">
                <v-btn icon small :to="{ name: 'roles-form', params: { role_id: props.item.id }}" color="success"
                       :ripple="false">
                  <v-icon size="18">edit</v-icon>
                </v-btn>
                <remove-dialog :yes="() => remove(props.item)">
                  <v-btn color="error" icon small :ripple="false">
                    <v-icon size="18">delete_forever</v-icon>
                  </v-btn>
                </remove-dialog>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins/'

  export default {
    name: 'RolesListPage',
    mixins: [mixins.removable, mixins.list, mixins.filter, mixins.preloader, mixins.user],
    data() {
      return {
        api: this.$api.roles,
        filter: {
          instance_id: "",
        },
        headers: [
          {text: 'Title', align: 'left', sortable: true, value: 'name'},
          {text: 'Action', align: 'right', sortable: false},
        ],
      }
    },
    methods: {
      getList(params) {
        return params.instance_id ? this.api.list(params) : new Promise(resolve => resolve({data: []}))
      },
    },
    computed: {
      instances() {
        /*return this.user.instanceUsers.filter(instance => {
          return instance.roles.map(item => item.features).flat().some(feature => feature.id == this.$features.ROLES)
        })*/
        return this.user.instanceUsers
      }
    },
    mounted() {
      this.filter.instance_id = this.instances[0].id
    }
  }
</script>
